<template>
  <div>
    <sub-main/>
  </div>
</template>
<script>
import SubMain from '../torreairea/mapLocation/SubMain'
export default {
  name: "SubMenu",
  components: {
    SubMain
  }
}
</script>
<style scoped>
</style>